import Slider from './components/Slider';
import BarraInicio from './components/BarraInicio';
import TecnoDev from './components/TecnoDev';
import ImagesSector from './components/ImagesSector';
import Footer from './components/Footer';

function RootPage(){
    return(
        <>
        <BarraInicio />
        <section id='opiniones'>
        <Slider />
        </section>
        <section id='backTencodev'>
        <ImagesSector />
        </section>
        <section id='sobreTecnodev'>
        <TecnoDev />
        </section>
        <Footer />
        </>
    )
}

export default RootPage